import api from "./api";


export async function getActiveDriversLocations() {
  const res = await api.get("admin/locations");
  return res.data.data;
}


export async function getCustomersWithPendingOrders() {
  const res = await api.get("admin/locations/customersWithPendingOrders");
  return res.data.data;
}